<template>
    <div class="lds-widget-card__item">
        <p
            class="lds-widget-card__item-name"
            v-if="name"
        >
            {{ name }}
        </p>
        <p
            class="lds-widget-card__item-value"
            v-if="value"
        >
            {{ value }} {{ symbol }}
        </p>
    </div>
</template>

<script setup>
defineProps({
    name: {
        type: String,
        required: true,
    },

    value: {
        type: [String, Number],
        required: true,
    },

    symbol: {
        type: String,
        default: '',
    },
});
</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>